module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Italic.fb214078.woff";